import { first } from 'lodash/fp';

import { PricingMode } from '@mews/enums';
import {
    LocalizedText,
    LocalizedCurrencyValue as MewsLocalizedCurrencyValue,
    LocalizedCurrencyValueProps as MewsLocalizedCurrencyValueProps,
} from '@mews/framework';
import { DistributorTextKey as TextKey } from './enums/DistributorTextKey';

const valueCheck = <V,>(value: V) => {
    if (Array.isArray(value)) {
        const nestedValue = first(value);
        if (Array.isArray(nestedValue)) {
            if (first(nestedValue) === 0) {
                return <LocalizedText textKey={TextKey.Free} />;
            }
        }
    }
    return undefined;
};

interface LocalizedCurrencyValueProps<O extends {}> extends MewsLocalizedCurrencyValueProps<unknown, O> {
    hasNetPricing?: boolean;
}

export const LocalizedCurrencyValue = <O extends {}>({
    hasNetPricing,
    options,
    // @ts-expect-error To fix: React does not recognize the `priceLabel` prop on a DOM element.
    priceLabel,
    ...props
}: LocalizedCurrencyValueProps<O>) => (
    <MewsLocalizedCurrencyValue
        options={{
            pricingMode: hasNetPricing === true ? PricingMode.Net : PricingMode.Gross,
            ...options,
        }}
        valueCheck={valueCheck}
        {...props}
    />
);
